import {
    IonButton,
    IonCard,
    IonCardSubtitle,
    IonCardTitle,
    IonCol,
    IonItem,
    IonLabel,
    IonList,
    IonReorder,
    IonReorderGroup,
    IonRow,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { ItemReorderEventDetail } from '@ionic/core';
import { Organization, PrizeMoneyTable } from "../../models";
import { getOrganizationById } from "../../utilities/organization/Organization";
import { getPrizeMoneyTablesByOrganizationId } from "../../utilities/prizeMoneyTable/PrizeMoneyTable";

interface _Props {
    organizationId: string
    onSelect: Function
}

let subscription: any;

const PrizeMoneyTableEditTable: React.FC<_Props> = ({organizationId, onSelect}) => {

    const [organization, setOrganization] = useState<Organization>();
    const [prizeMoneyTables, setPrizeMoneyTables] = useState<PrizeMoneyTable[] | null | undefined>();
    const [enableReorder, setEnableReorder] = useState(false);
    const [isOrderDifferent, setIsOrderDifferent] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        async function getOrganization() {
            const queryResult = await getOrganizationById(organizationId);
            if (queryResult.isSuccess) {
                setOrganization(queryResult.result);
                getPrizeMoneyTables(queryResult.result);
                setPrizeMoneyTableSubscription(queryResult.result);
            } else {
                setError("Sorry, a problem occurred. Please go back and try again.");
            }
        }

        async function setPrizeMoneyTableSubscription(organization: Organization) { 
            // subscription = DataStore.observe(PrizeMoneyTable).subscribe(() => {
            //     if (organization) getPrizeMoneyTables(organization);
            //     else console.error("No organization to check for new prize money tables")
            // });
        }

        getOrganization();

        return () => {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
    }, [organizationId]);

    async function getPrizeMoneyTables(organization: Organization) {
        const queryResult = await getPrizeMoneyTablesByOrganizationId(organization.id);
        if (queryResult.isSuccess) {
            setPrizeMoneyTables(queryResult.result);
        }
    }

    function doReorder(event: CustomEvent<ItemReorderEventDetail>) {
        // The `from` and `to` properties contain the index of the item
        // when the drag started and ended, respectively
      
        setIsOrderDifferent(true);

        // Finish the reorder and position the item in the DOM based on
        // where the gesture ended. This method can also be called directly
        // by the reorder group
        event.detail.complete();
    }

    const handleNewOrder = () => {
        setIsOrderDifferent(false);
    }

    const onSelectPrizeMoneyTable = (table: PrizeMoneyTable) => {
        onSelect(table);
    }

    return (
        <IonCard mode="md" className="ion-padding bg-white">
            <IonCardTitle>Your Prize Money Tables</IonCardTitle>
            <IonCardSubtitle color="danger">Refresh page to see changes.</IonCardSubtitle>
            <IonCardSubtitle>Click on a table to edit it.</IonCardSubtitle>
            {/* <IonRow>
                <IonCol sizeXs="12" sizeMd="8" sizeLg="6">
                    <IonItem lines="none">
                        <IonLabel slot="start">Re-Order?</IonLabel>
                        <IonToggle color="tertiary" checked={enableReorder} onIonChange={e => setEnableReorder(e.detail.checked)}/>
                    </IonItem> 
                </IonCol>
            </IonRow> */}
            {isOrderDifferent && (
                <IonRow>
                    <IonCol>
                        <IonButton color="tertiary" onClick={handleNewOrder}>Save New Order</IonButton>
                    </IonCol>
                </IonRow>
            )}
            <IonList className="bg-white">
                {prizeMoneyTables && prizeMoneyTables.length ?
                    <IonReorderGroup disabled={!enableReorder} onIonItemReorder={doReorder}>
                        {prizeMoneyTables.map((pmt, index) => (
                            <IonItem key={index} onClick={() => onSelectPrizeMoneyTable(pmt)}>
                                <IonLabel>
                                    {pmt.name} ({pmt.isPercentage ? "%" : "$"})
                                    <br/>
                                    <p className="description">{pmt.description}</p>
                                </IonLabel>
                                <IonReorder slot="start" />
                            </IonItem>
                        ))}
                    </IonReorderGroup>
                    :
                    <p>No tables yet.</p>
                }
            </IonList>
        </IonCard>
    );
};

export default PrizeMoneyTableEditTable;